import { useStoreState } from "ezStore";
import { intl } from "LocaleWrapper";
import { Select, SelectProps } from "@cofano/cck";
import { Fields, hasOptionalFieldPermission } from "imports/Utils";
import { CallType, StatusEstimateType, StatusType } from "__generated__/enums";

const StatusEstimateTypeSelect = ({ value, onChange, type, cargoActionType }: Omit<SelectProps<StatusEstimateType, false>, "fetchOptions"> & { type: StatusType; cargoActionType: CallType | null }) => {

	const session = useStoreState(state => state.session);

	// we need the action type to be set to be able to update call times (cargo -> action -> call)
	const cargoStatusWithEstimation = cargoActionType != null && type === StatusType.Cargo;

	const options = [ {
		id: StatusEstimateType.Eta,
		name: intl.formatMessage({ id: "STATUS_ETA_FULL" }),
		enabled: (type === StatusType.Call || cargoStatusWithEstimation) && hasOptionalFieldPermission(session, Fields.CALL, "skipperETA"),
	}, {
		id: StatusEstimateType.Etd,
		name: intl.formatMessage({ id: "STATUS_ETD_FULL" }),
		enabled: type === StatusType.Call || cargoStatusWithEstimation,
	}, {
		id: StatusEstimateType.Etso,
		name: intl.formatMessage({ id: "STATUS_ETSO_FULL" }),
		enabled: (type === StatusType.Call || cargoStatusWithEstimation) && hasOptionalFieldPermission(session, Fields.CALL, "startOperationTimes"),
	}, {
		id: StatusEstimateType.Eteo,
		name: intl.formatMessage({ id: "STATUS_ETEO_FULL" }),
		enabled: (type === StatusType.Call || cargoStatusWithEstimation) && hasOptionalFieldPermission(session, Fields.CALL, "startOperationTimes"),
	}, {
		id: StatusEstimateType.StatusChange,
		name: intl.formatMessage({ id: "ESTIMATED_TIME" }),
		enabled: type === StatusType.Cargo,
	} ];

	return (
		<Select
			disableSearch
			clearable
			fetchOptions={[ ...options ].filter(option => option.enabled)}
			value={options.find(option => option.id === value)}
			onChange={(option) => onChange?.(option?.id ?? null, false)} />
	);
};

export default StatusEstimateTypeSelect;
